export default "__VITE_ASSET__7631b925__"